<template>
  <v-row class="ftc" align-content="center" justify="start">
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn
          color="green"
          size="x-small"
          variant="plain"
          append-icon="mdi-plus"
          v-bind="props"
        >
          Definir Fonte do Requisito
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Definir Fonte do Requisito</span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" validate-on="lazy submit">
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="fonteRequisito"
                    :items="fontesRequisito"
                    label="Tipo de Fonte*"
                    :rules="fonteRequisitoRules"
                  ></v-select>
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-if="fonteRequisito == 'EXTERNO'"
                    v-model="stakeHolderESelected"
                    :items="stakeHolderENomes"
                    label="Fonte Requisito*"
                    :rules="stakeHolderESelectedRules"
                  ></v-select>
                  <v-select
                    v-else-if="fonteRequisito == 'EQUIPE'"
                    v-model="usuarioSelected"
                    :items="usuariosNomes"
                    label="Fonte Requisito*"
                    :rules="usuarioSelectedRules"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*Campo obrigatório</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue-darken-1" variant="text" @click="submitForm">
            Salvar
            <v-progress-circular
              v-if="this.isLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 * @module FonteRequisito
 * @desc Recebe os dados da fonte do requisito.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o
 * diálogo está aberto ou fechado.
 * @vue-data {number} [idProjeto=null] - O ID do projeto
 *  associado ao componente, ou null se nenhum projeto estiver associado.
 * @vue-data {string} [fonteRequisito=''] - A fonte do requisito.
 * @vue-data {Array<string>} [fontesRequisito=[]] - Uma matriz de
 * strings que representa todas as fontes possíveis de requisitos.
 * @vue-data {Array<Object>} [stakeHolderE=[]] - Uma matriz de objetos
 *  que representam as partes interessadas envolvidas no projeto.
 * @vue-data {Array<string>} [stakeHolderENomes=[]] - Uma matriz de
 *  strings que representa os nomes das partes interessadas envolvidas
 *  no projeto.
 * @vue-data {number} [stakeHolderEId=null] - O ID da parte interessada
 * selecionada, ou null se nenhuma parte interessada estiver selecionada.
 * @vue-data {string} [stakeHolderESelected=''] - O nome da parte
 * interessada selecionada.
 * @vue-data {Array<Object>} [usuarios=[]] - Uma matriz de objetos
 * que representam os usuários envolvidos no projeto.
 * @vue-data {Array<string>} [usuariosNomes=[]] - Uma matriz de strings
 *  que representa os nomes dos usuários envolvidos no projeto.
 * @vue-data {number} [usuarioId=null] - O ID do usuário selecionado, ou
 * null se nenhum usuário estiver selecionado.
 * @vue-data {string} [usuarioSelected=''] - O nome do usuário selecionado.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se a fonte está
 * sendo criada.
 */
import axios from 'axios';

import store from '@/store/store';
const apiUrl = process.env.VUE_APP_API_URL;
export default {
  props: {
    id: Number,
  },
  emits: ['fonteAlterada'],
  data: () => ({
    dialog: false,
    idProjeto: null,
    fonteRequisito: '',
    fontesRequisito: ['EQUIPE', 'EXTERNO'],
    stakeHolderE: [],
    stakeHolderENomes: [],
    stakeHolderEId: null,
    stakeHolderESelected: '',
    usuarios: [],
    usuariosNomes: [],
    usuarioId: null,
    usuarioSelected: '',
    isLoading: false,
    fonteRequisitoRules: [(v) => !!v || 'Tipo da fonte é obrigatório'],
    stakeHolderESelectedRules: [
      (v) => !!v || 'Stakeholder externo é obrigatório',
    ],
    usuarioSelectedRules: [(v) => !!v || 'Usuário é obrigatório'],
  }),
  created() {
    this.idProjeto = this.$route.params.idProjeto;
    this.fetchStakeHolders(this.idProjeto);
    this.fetchUsuarios(this.idProjeto);
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Retorna os stakeholders do projeto
     *
     * @param {Number} id O id do projeto
     */
    async fetchStakeHolders(id) {
      try {
        const response = await axios.get(
          apiUrl + '/api/v1/stakeHolderE/projeto/' + id,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.stakeHolderE = response.data.stakeHolderE;
        this.stakeHolderENomes = this.stakeHolderE.map(
          (stakeH) => stakeH.tb_stakeholder_externo.nome,
        );
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Retorna os usuários que estão no projeto.
     *
     * @param {Number} id O id do projeto
     */
    async fetchUsuarios(id) {
      try {
        const response = await axios.get(apiUrl + '/usuarios/projeto/' + id, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        });
        this.usuarios = response.data.usuarios;
        this.usuarios = this.usuarios[0].tb_equipe.tb_membro;
        this.usuariosNomes = this.usuarios.map(
          (usuario) => usuario.tb_usuario.nome,
        );
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Retorna o ID do stakeholder.
     */
    pegaIdStakeHolder() {
      for (var i = 0; i < this.stakeHolderE.length; i++) {
        if (
          this.stakeHolderE[i].tb_stakeholder_externo.nome ==
          this.stakeHolderESelected
        ) {
          this.stakeHolderEId =
            this.stakeHolderE[i].tb_stakeholder_externo.id_stakeholder;
        }
      }
    },
    pegaIdUsuario() {
      for (var i = 0; i < this.usuarios.length; i++) {
        if (this.usuarios[i].tb_usuario.nome == this.usuarioSelected) {
          this.usuarioId = this.usuarios[i].tb_usuario.id_usuario;
        }
      }
    },
    async submitForm() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        if (this.fonteRequisito == 'EQUIPE') {
          this.pegaIdUsuario();
        } else {
          this.pegaIdStakeHolder();
        }
        const data = {
          // eslint-disable-next-line
          id_stakeholder: this.stakeHolderEId,
          // eslint-disable-next-line
          id_usuario: this.usuarioId,
          // eslint-disable-next-line
          tipo_fonte: this.fonteRequisito,
          // eslint-disable-next-line
          id_requisito: this.id,
        };
        try {
          this.isLoading = true;
          const apiUrl = process.env.VUE_APP_API_URL;
          const response = await axios.post(
            `${apiUrl}/api/v1/requisitos/fonte`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          this.$toast.success(response.data.msg);
          this.$emit('fonteAlterada');
          this.$router.push(
            `/projects/${this.idProjeto}/Requisitos/${this.id}`,
          );
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoading = false;
          this.dialog = false;
        }
      }
    },
  },
};
</script>
<style>
.ftc {
  width: fit-content;
}
</style>
